import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { Button } from '@xing-com/button';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';
import { IconButterflyMono } from '@xing-com/icons';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  space3XL,
  spaceXXL,
  xdlColorCardHero01,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { BodyCopy, Hero } from '@xing-com/typography';

import BannerImage from './assets/LO_summary_Eng.svg';
import BannerImageGer from './assets/LO_summary_Ger.svg';

const StyledBanner = styled(ContentBanner)`
  display: none;

  @media ${mediaConfined} {
    display: flex;
    color: ${xdlColorTextOnLight};
    padding: ${spaceXXL} ${space3XL};
  }

  @media (prefers-color-scheme: light) {
    background-color: ${xdlColorCardHero01};
  }
`;

export type MatchingBannerProps = { globalId: string };

export const MatchingBanner: React.FC<MatchingBannerProps> = ({ globalId }) => {
  const { locale } = useIntl();
  const nwtTrack = useJobsNwtTracking();

  const onRegisterClick = (): void => {
    nwtTrack({
      eventSchema: 'basic',
      itemUrn: globalId,
      page: 'jobs/detail',
      event: 'opened',
      element: 'register',
      elementDetail: 'matching_communication',
    });
  };

  return (
    <StyledBanner display="inline">
      <div>
        <Hero size="medium" as="h2">
          <FormattedMessage id="JOBS_JOB_DETAILS_MATCHING_BANNER_HEADLINE" />
        </Hero>
        <BodyCopy size="large">
          <FormattedMessage id="JOBS_JOB_DETAILS_MATCHING_BANNER_DESCRIPTION" />
        </BodyCopy>
        <Button
          variant="onColorStrong"
          icon={IconButterflyMono}
          to="/start/signup?signup_channel=jobs_jdp_matching_communication&sc_o=jobs_jdp_matching_communication_register_click"
          onClick={onRegisterClick}
        >
          <FormattedMessage id="JOBS_JOB_DETAILS_MATCHING_BANNER_REGISTER" />
        </Button>
      </div>
      <img src={locale === 'en' ? BannerImage : BannerImageGer} alt="" />
    </StyledBanner>
  );
};
